import { render } from "./VLoadingScreen.vue?vue&type=template&id=10b5a81a"
import script from "./VLoadingScreen.vue?vue&type=script&lang=js"
export * from "./VLoadingScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__